export default __webpack_public_path__ + "static/media/wallpaper.150ca6b7.jpeg";